module.exports = __webpack_public_path__ + "img/80f4502e805e317dda235ad4d0a88fa2.png";